module.exports = __webpack_public_path__ + "static/media/220214-CTN_012_alpha_2.6dc3b838.png";